module.exports = __webpack_public_path__ + "img/picture.4ff1b89e.png";